import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import AssessmentPage from './pages/AssessmentPage';
import CapabilitiesPage from './pages/CapabilitiesPage';
import MarketResearchPage from './pages/MarketResearchPage';
import PeopleAndPlacesPage from './pages/PeopleAndPlacesPage';
import StrategicPartnersPage from './pages/StrategicPartnersPage';
import ConsultingSolutionsPage from './pages/ConsultingSolutionsPage';
import RightPathPage from './pages/RightPathPage';
import PressPage from './pages/PressPage';
import SponsorshipPage from './pages/SponsorshipPage';
import R6AdvisoryPage from './pages/R6AdvisoryPage';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import PortalLogin from './pages/portal/PortalLogin';
import PortalSignup from './pages/portal/PortalSignup';
import PaymentSuccess from './pages/portal/PaymentSuccess';
import PortalLayout from './components/PortalLayout';
import ClientDashboard from './pages/portal/ClientDashboard';
import ClientSessions from './pages/portal/ClientSessions';
import ClientQuestions from './pages/portal/ClientQuestions';
import ClientResources from './pages/portal/ClientResources';
import ClientPlan from './pages/portal/ClientPlan';
import AdminDashboard from './pages/portal/AdminDashboard';
import AdminClients from './pages/portal/AdminClients';
import AdminCoaches from './pages/portal/AdminCoaches';
import AdminQuestions from './pages/portal/AdminQuestions';
import AdminSessions from './pages/portal/AdminSessions';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Montserrat' }}>Loading...</div>;
  if (!user) return <Navigate to="/portal/login" />;
  if (requiredRole && user.role !== requiredRole) return <Navigate to={user.role === 'admin' ? '/portal/admin' : '/portal/dashboard'} />;
  return children;
};

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <div className="App">
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/assessment" element={<AssessmentPage />} />
            <Route path="/capabilities" element={<CapabilitiesPage />} />
            <Route path="/consulting-solutions" element={<ConsultingSolutionsPage />} />
            <Route path="/the-right-path" element={<RightPathPage />} />
            <Route path="/market_research" element={<MarketResearchPage />} />
            <Route path="/people-and-places" element={<PeopleAndPlacesPage />} />
            <Route path="/strategic-partners" element={<StrategicPartnersPage />} />
            <Route path="/press" element={<PressPage />} />
            <Route path="/sponsorship" element={<SponsorshipPage />} />
            <Route path="/r6-advisory" element={<R6AdvisoryPage />} />

            {/* Portal */}
            <Route path="/portal/login" element={<PortalLogin />} />
            <Route path="/portal/signup" element={<PortalSignup />} />
            <Route path="/portal/signup/success" element={<PaymentSuccess />} />
            <Route path="/portal" element={<ProtectedRoute><PortalLayout /></ProtectedRoute>}>
              <Route path="dashboard" element={<ClientDashboard />} />
              <Route path="sessions" element={<ClientSessions />} />
              <Route path="questions" element={<ClientQuestions />} />
              <Route path="resources" element={<ClientResources />} />
              <Route path="plan" element={<ClientPlan />} />
              <Route path="admin" element={<ProtectedRoute requiredRole="admin"><AdminDashboard /></ProtectedRoute>} />
              <Route path="admin/clients" element={<ProtectedRoute requiredRole="admin"><AdminClients /></ProtectedRoute>} />
              <Route path="admin/coaches" element={<ProtectedRoute requiredRole="admin"><AdminCoaches /></ProtectedRoute>} />
              <Route path="admin/questions" element={<ProtectedRoute requiredRole="admin"><AdminQuestions /></ProtectedRoute>} />
              <Route path="admin/sessions" element={<ProtectedRoute requiredRole="admin"><AdminSessions /></ProtectedRoute>} />
            </Route>
          </Routes>
        </Router>
      </div>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
